/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getLongHeadlineStyles = ({ styleOverrides }) => () => {
  return {
    longHeadline: _.extend({
    }, styleOverrides.longHeadline),
  };
};
